import { useQuery } from "@tanstack/react-query";
import {
	type GetProductChangesParams,
	getProductChanges,
	getProductChangesPickers,
} from "../repositories/ProductChangesRepository";

type UseProductChangesParams = Omit<GetProductChangesParams, "signal"> & {
	// The screen does not run on its own: nothing is fetched until a filter is touched.
	enabled: boolean;
};

export const useProductChangesData = ({
	start,
	end,
	productSizeId,
	enabled,
}: UseProductChangesParams) =>
	useQuery({
		queryKey: ["productChanges", start, end, productSizeId],
		queryFn: ({ signal }) =>
			getProductChanges({ start, end, productSizeId, signal }),
		enabled: enabled && !!start && !!end,
		// React Query retries three times by default. On a call that fails by timing out —
		// the legacy branch does, on any wide range — that is a minute and a half of
		// spinner before the error is ever shown. Fail on the first answer instead.
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useProductChangesPickers = () =>
	useQuery({
		queryKey: ["productChangesPickers"],
		queryFn: ({ signal }) => getProductChangesPickers(signal),
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
